import { render, staticRenderFns } from "./LostOtpModal.vue?vue&type=template&id=69359117&scoped=true"
import script from "./LostOtpModal.vue?vue&type=script&lang=js"
export * from "./LostOtpModal.vue?vue&type=script&lang=js"
import style0 from "./LostOtpModal.vue?vue&type=style&index=0&id=69359117&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69359117",
  null
  
)

export default component.exports